/*
 * Copyright 2020 The Backstage Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  ApiBlueprint,
  createApiFactory,
  createFrontendPlugin,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/frontend-plugin-api'
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha'
import { createElement } from 'react'

import { CircleCIApi, circleCIApiRef } from './api'
import { isCircleCIAvailable } from './components/Router'
import { circleCIRouteRef } from './route-refs'

const circleCIApiExtension = ApiBlueprint.make({
  name: 'circleci',
  params: defineParams =>
    defineParams(
      createApiFactory({
        api: circleCIApiRef,
        deps: { discoveryApi: discoveryApiRef, fetchApi: fetchApiRef },
        factory: ({ discoveryApi, fetchApi }) => new CircleCIApi({ discoveryApi, fetchApi }),
      })
    ),
})

const entityCircleCIContent = EntityContentBlueprint.make({
  name: 'circleci',
  params: {
    path: '/circleci',
    title: 'Circle CI',
    routeRef: circleCIRouteRef,
    filter: isCircleCIAvailable,
    loader: () => import('./components/Router.tsx').then(m => createElement(m.Router)),
  },
})

/** @public */
export const circleCIPlugin = createFrontendPlugin({
  pluginId: 'circleci',
  routes: {
    root: circleCIRouteRef,
  },
  extensions: [circleCIApiExtension, entityCircleCIContent],
})

export default circleCIPlugin
